import { AnyAction } from 'redux';
import {
  LOGIN_ERROR,
  LOGIN_SET_IS_LOADING,
  LOGIN_SET_LOGIN_MODE,
  LOGIN_SET_MAGIC_LINK_MODEL,
  LOGIN_SET_MODAL_OPEN,
  LOGIN_SET_ORGANIZATIONS,
  LOGIN_SET_REDIRECT_URL,
  LOGIN_SET_USERNAME_PASSWORD,
  LOGIN_SET_TERMS,
  LoginModes,
} from '../constants';

const DEFAULT_STATE = {
  showChangePassword: false,
  isLoading: false,
  username: '',
  password: '',
  modalOpen: false,
  loginMode: LoginModes.Login,
  error: undefined,
  redirectUrl: undefined,
  registerUrl: undefined,
  terms: '',
};

export const login = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LOGIN_SET_IS_LOADING:
    case LOGIN_SET_ORGANIZATIONS:
    case LOGIN_SET_MODAL_OPEN:
    case LOGIN_SET_USERNAME_PASSWORD:
    case LOGIN_SET_LOGIN_MODE:
    case LOGIN_ERROR:
    case LOGIN_SET_TERMS:
    case LOGIN_SET_REDIRECT_URL:
    case LOGIN_SET_MAGIC_LINK_MODEL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
